export default "__VITE_ASSET__47DKRRkt__"